// extracted by mini-css-extract-plugin
module.exports = {"titleIcon":"ViewChargeAffirm_titleIcon__3yJqI","inputPhoneContainer":"ViewChargeAffirm_inputPhoneContainer__3c-Go"};